<template>
  <div class="row">
    <div class="col-md-12">
      <h1 class="h3 mb-3 text-gray-800">Gestão de Benefício</h1>
    </div>
    <load
      mode="table"
      v-if="loadingBeneficios"
      message="Carregando informações dos benefícios"
    />
    <div class="col-md-12" v-else>
      <!--Tabela-->
      <div class="row">
        <div class="col-md-12">
          <div class="card mb-0 shadow">
            <div class="card-body">
              <div class="tab-content">
                <div
                  v-if="!novo_beneficio"
                  class="animate__animated animate__fadeIn"
                >
                  <div class="row">
                    <div class="col-12">
                      <div
                        class="d-flex align-items-center justify-content-between mb-4"
                      >
                        <div>
                          <button
                            class="btn btn-primary"
                            @click="novo_beneficio = true"
                          >
                            <i class="fas fa-plus-square" />
                            {{ $t("Cadastrar") }}
                          </button>
                          <button
                            v-if="isGestor"
                            class="btn btn-success"
                            @click="redirectLiberar"
                          >
                            <i class="mdi mdi-cached" />
                            {{ $t("Gestão de Concessões") }}
                          </button>
                          <button
                            v-if="isGestor"
                            class="btn btn-info"
                            @click="redirectEntregue"
                          >
                            <i class="mdi mdi-calendar-check" />
                            {{ $t("Benefícios entregues") }}
                          </button>
                        </div>
                        <div>
                          <b-button-group>
                            <b-button
                              variant="outline-dark"
                              :class="viewFilterReport === true ? 'active' : ''"
                              @click="viewFilters"
                            >
                              <i class="fas fa-filter"></i>
                              {{ $t("Filtros") }}
                            </b-button>
                            <b-button variant="outline-dark" @click="print()">
                              <i class="fas fa-print"></i>
                            </b-button>

                            <b-button
                              v-b-tooltip.hover
                              :title="$t('Exportar')"
                              variant="outline-dark"
                              @click="exportar()"
                            >
                              <i class="fas fa-file-excel"></i>
                            </b-button>
                          </b-button-group>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12" v-if="viewFilterReport">
                      <!-- Filtros -->
                      <form @submit.prevent="getBeneficios" ref="addItem">
                        <div class="row">
                          <form-select
                            v-model="filtroUnidades"
                            label="Filtrar por Unidade"
                            grid="6"
                            :itens="unidades"
                            :disabled="desabledSearchUnidade"
                            :loading="loadingSearchUnidade"
                            :multiple="true"
                          />

                          <form-select
                            v-model="filtroTipos"
                            label="Filtrar por Tipo"
                            grid="6"
                            :itens="tipos"
                            :disabled="loadingSearchTipos"
                            :loading="loadingSearchTipos"
                            :multiple="true"
                          />

                          <form-select
                            v-model="filtroFonteRecursos"
                            label="Fonte do Recurso"
                            grid="6"
                            :itens="$root.arrays.beneficio_fonte"
                            :multiple="true"
                          />

                          <form-select
                            v-model="filtroCategorias"
                            label="Categoria"
                            grid="6"
                            :itens="$root.arrays.beneficio_categoria"
                            :multiple="true"
                          />

                          <form-calendar
                            v-model="data_inicio"
                            grid="3"
                            label="Data inicial"
                            :max-date="dataNow"
                          />

                          <form-calendar
                            v-model="data_fim"
                            grid="3"
                            label="Data final"
                            :required="verificaDataInicial"
                            :min-date="data_inicio"
                            :max-date="dataNow"
                          />

                          <form-select
                            v-model="filtroStatus"
                            grid="6"
                            label="Status"
                            :itens="status"
                            :loading="loadingStatus"
                            :disabled="loadingStatus"
                            :multiple="true"
                          />

                          <form-toggle
                            v-model="filtrarConcessoes"
                            grid="12"
                            label="Filtrar por Número de Concessões?"
                          />

                          <template v-if="filtrarConcessoes">
                            <div class="col-md-12 mb-3">
                              <label><b>Número de Concessões</b></label>
                              <vue-slider
                                v-model="filtroConcessoes"
                                :min="min"
                                :max="quatidade_maxima"
                                :tooltip="'always'"
                                :tooltip-placement="'bottom'"
                              ></vue-slider>
                            </div>
                          </template>
                        </div>
                        <div
                          class="row pt-4 mb-4 px-0 d-flex justify-content-end"
                        >
                          <div class="col-auto px-2 text-right">
                            <button
                              class="btn btn-default"
                              @click="viewFilters"
                            >
                              <i class="fas fa-times"></i>
                            </button>

                            <button
                              type="button"
                              class="btn btn-secondary"
                              @click.prevent="limparFiltros"
                            >
                              {{ $t("Limpar Filtros") }}
                            </button>
                            <button
                              class="btn btn-success btn-submit"
                              data-style="zoom-in"
                              type="submit"
                            >
                              <i class="fas fa-chart-bar"></i>
                              {{ $t("Gerar Relatório") }}
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                    <div class="col-12">
                      <print-content>
                        <template v-slot:datas>
                          <p
                            class="d-flex align-items-center justify-content-between mb-4"
                          >
                            <span
                              >Período selecionado:
                              <b>{{ datas.start }} - {{ datas.end }}</b>
                              <b-link
                                href="#"
                                @click.prevent="void 0"
                                class="mb-2"
                                variant="info"
                                v-b-popover.hover.top="
                                  'Através do botão filtros você pode selecionar um intervalo de datas para impressão de seus dados.'
                                "
                              >
                                <i class="fas fa-info-circle"></i> </b-link
                            ></span>

                            <span v-if="pagination.total"
                              >Total de Registros <b>{{ pagination.total }}</b
                              >, total por página
                              <b>{{ pagination.perPage }}</b></span
                            >
                          </p>
                        </template>
                        <b-table
                          :fields="[
                            {
                              key: 'nome',
                              label: $t('Nome'),
                            },
                            {
                              key: 'liberados',
                              label: $t('Concessões'),
                            },
                            {
                              key: 'cadastrado',
                              label: $t('Cadastrado'),
                            },
                            {
                              key: 'status_nome',
                              label: $t('Status'),
                            },
                            {
                              key: 'actions',
                              label: '',
                              class: 'text-right no-print',
                              thStyle: {
                                width: '95px',
                                minWidth: '95px',
                              },
                            },
                          ]"
                          :items="beneficiosList"
                          :responsive="true"
                          striped
                          hover
                          show-empty
                          small
                          outlined
                          stacked="xs"
                          table-class="mb-3"
                        >
                          <template v-slot:cell(nome)="data">
                            Nome:
                            <b>{{ data.item.nome }}</b>
                            <br />
                            Tipo: <b>{{ data.item.tipo_nome }}</b>
                            <br />
                            Fonte do Recurso:
                            <b>{{ data.item.fonte_recurso_nome }}</b>
                            <br />
                            Categoria:
                            <b>{{ data.item.categoria_nome }}</b>
                            <br />
                            Protocolo:
                            <b>{{ data.item.protocolo }}</b>
                            <br />
                            <span
                              class="small"
                              v-if="data.item.unidades && data.item.unidades.length > 0"
                            >
                              Unidades
                              <ul>
                                <li
                                  v-for="unidade in data.item.unidades_nomes"
                                  :key="unidade.id"
                                >
                                  <b>{{ unidade.nome }}</b>
                                </li>
                              </ul>
                            </span>
                          </template>
                          <template v-slot:cell(liberados)="data">
                            <span class="small text-muted">
                              Concessões:
                              <b>{{ data.item.liberados_qtd }}</b>
                              <br />

                              <span v-if="data.item.categoria != 1">
                                Qtd. cadastrada:
                                <b>{{ data.item.quantidade }}</b>
                                <br />
                                Qtd. entregue:
                                <b>{{ data.item.quantidade_entregue }}</b>
                                <br />
                                Qtd. disponível:
                                <b>{{ data.item.quantidade - data.item.quantidade_entregue }}</b>
                              </span>

                              <span v-if="data.item.categoria == 1">
                                Vlr. cadastrado:
                                <b>{{ formatarValor(data.item.valor) }}</b>
                                <br />
                                Vlr. entregue:
                                <b>{{ formatarValor(somarValoresLiberados(data.item)) }}</b>
                                <br />
                                Vlr. disponível:
                                <b>{{ calcularValorDisponivel(data.item) }}</b>
                              </span>
                            </span>

                            <b-link
                              href="#"
                              v-if="(data.item.categoria === 2 && data.item.quantidade_entregue > data.item.quantidade) ||
                                    (data.item.categoria === 1 && obterValorDisponivelNumerico(data.item) < 0)"
                              v-b-tooltip.hover
                              title="Atenção! O número de concessões neste benefício é maior que a quantidade disponível"
                            >
                              <b-icon
                                icon="exclamation-triangle-fill"
                                variant="warning"
                                animation="fade"
                              ></b-icon>
                            </b-link>
                          </template>
                          <template v-slot:cell(cadastrado)="data">
                            <b v-html="data.item.cadastrado"></b>
                          </template>
                          <template v-slot:cell(status_nome)="data">
                            <span
                              class="small"
                              v-html="data.item.status_nome"
                            ></span>
                          </template>
                          <template v-slot:cell()="data">
                            <button
                              @click="redirectBeneficio(data.item.id)"
                              class="px-2 mb-0 btn btn-sm btn-success"
                            >
                              <i class="mdi mdi-square-edit-outline" />
                            </button>
                          </template>
                          <template v-slot:empty="scope">
                            <div class="text-center my-5">
                              <img
                                :alt="$t('No results')"
                                class="mb-5"
                                src="/img/icons/robot.svg"
                                style="max-height: 165px"
                              />
                              <h3 class="bold">
                                {{ $t("No records found") }}
                              </h3>
                            </div>
                          </template>
                        </b-table>
                      </print-content>
                      <div class="row align-items-center no-print">
                        <div class="col-lg-6 col-md-12">
                          <div class="form-group d-inline-flex mb-0">
                            <select
                              class="form-control"
                              style="width: 70px"
                              v-model="perPage"
                              v-on:change="getBeneficios"
                            >
                              <option value="5">5</option>
                              <option value="10">10</option>
                              <option value="25">25</option>
                              <option value="50">50</option>
                              <option value="100">100</option>
                            </select>
                          </div>
                          <div class="d-inline-flex ml-2">
                            <b-pagination
                              :per-page="perPage"
                              :total-rows="pagination.total"
                              @change="changePage"
                              v-model="page"
                            />
                          </div>
                        </div>
                        <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
                          <div class="float-lg-right">
                            {{ $t("Showing page") }}
                            {{ pagination.currentPage }}
                            de
                            {{ pagination.totalPages }}
                            {{ $t("pages in") }}
                            {{ pagination.total }}
                            {{ $t("records") }}
                          </div>
                        </div>
                      </div>

                      <div class="box-btn-print no-print">
                        <b-button
                          v-if="!loadingBeneficios"
                          :title="$t('Visualizar e Imprimir')"
                          class="py-2"
                          size="sm"
                          type="button"
                          v-b-tooltip.hover
                          variant="primary"
                          @click="print()"
                        >
                          <i class="fas fa-print"></i>
                        </b-button>
                      </div>
                    </div>
                  </div>
                </div>
                <NovoBeneficio v-else @voltar="novo_beneficio = false" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import NovoBeneficio from "./Add";
export default {
  components: { NovoBeneficio },
  name: "Beneficios",
  metaInfo() {
    return {
      title: this.$i18n.t("Beneficios"),
    };
  },
  data() {
    return {
      familia: {},
      novo_beneficio: false,
      TipobeneficiosList: [],
      beneficiosList: [],
      page: 1,
      search: "",
      perPage: 10,
      loadingBeneficios: true,
      loading: true,
      isGestor: false,
      pagination: {
        currentPage: 0,
        perPage: 0,
        total: 0,
        totalPages: 0,
      },
      datas: [],
      quatidade_maxima: [],

      loadingSearchUnidade: true,
      desabledSearchUnidade: true,
      loadingSearchTecnicos: true,
      loadingSearchTipos: true,
      loadingStatus: false,

      status: [],
      unidades: [],
      tipos: [],
      data_inicio: "",
      data_fim: "",

      filtroDatas: [],
      filtroConcessoes: [0, 0],
      filtrarConcessoes: false,
      filtroFonteRecursos: [],
      filtroCategorias: [],
      filtroTipos: [],
      filtroUnidades: [],
      filtroStatus: [],
    };
  },
  created() {
    this.min = 0;
    this.max = 0;
    this.enableCross = false;
  },
  mounted() {
    this.getStatus();
    this.getTipos();
    this.getUnidades();
    this.getBeneficios();
  },
  updated() {
    if (this.$store.state.user) {
      this.isGestor =
        this.$store.state.user.permissions["BeneficioController"] == true ||
        role_user == "Admin"
          ? true
          : false;
    }
  },
  methods: {
    // Formata valor numérico (float ou int) para R$ x.xxx,xx
    formatarValor(valor) {
      const numero = parseFloat(valor);

      if (isNaN(numero)) return 'R$ 0,00';

      return numero.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      });
    },

    // Soma os valores do array de liberados
    somarValoresLiberados(item) {
      if (!item.liberados || !Array.isArray(item.liberados)) return 0;

      return item.liberados
        .filter(lib => lib.status_liberacao === 6 || lib.status_liberacao === 4)
        .reduce((soma, lib) => {
          const valor = parseFloat(lib.valor || 0);
          return soma + (isNaN(valor) ? 0 : valor);
        }, 0);
    },

    // Subtrai valor entregue do valor cadastrado
    calcularValorDisponivel(item) {
      const valorCadastrado = parseFloat(item.valor || 0);
      const valorEntregue = this.somarValoresLiberados(item);
      const valorDisponivel = valorCadastrado - valorEntregue;

      return this.formatarValor(valorDisponivel);
    },

    obterValorDisponivelNumerico(item) {
      const valorCadastrado = parseFloat(item.valor || 0);
      const valorEntregue = this.somarValoresLiberados(item);
      return valorCadastrado - valorEntregue;
    },

    getBeneficios() {
      this.loadingBeneficios = true;

      this.filtroDatas = [];
      if (this.data_inicio) {
        this.filtroDatas.push(
          this.$options.filters.formatDateYMD(this.data_inicio)
        );
      }
      if (this.data_fim) {
        this.filtroDatas.push(
          this.$options.filters.formatDateYMD(this.data_fim)
        );
      }

      axios
        .get("api/dashboard/beneficios", {
          params: {
            page: this.page,
            search: this.search,
            perPage: this.perPage,
            filtroDatas: this.filtroDatas,
            filtroConcessoes:
              this.filtroConcessoes[1] > 0 ? this.filtroConcessoes : null,
            filtroFonteRecursos: this.filtroFonteRecursos,
            filtroCategorias: this.filtroCategorias,
            filtroTipos: this.filtroTipos,
            filtroUnidades: this.filtroUnidades,
            filtroStatus: this.filtroStatus,
          },
        })
        .then((response) => {
          this.datas = response.data.datas;
          this.beneficiosList = response.data.dados.original.data;

          this.pagination = response.data.dados.original.pagination;
          this.quatidade_maxima = response.data.quatidade_maxima;

          this.filtroConcessoes = [filtroConcessoes[0], this.quatidade_maxima];

          if (this.pagination.totalPages < this.pagination.currentPage) {
            this.page = this.pagination.totalPages;
            this.getBeneficios();
          } else {
            this.loadingBeneficios = false;
          }
        })
        .catch(() => {
          this.loadingBeneficios = false;
        });
    },
    exportar() {
      this.isLoadingMsg = true;
      this.loading = true;
      swal.fire({
        title: "Aguarde! O Arquivo está sendo gerado.",
        text: "O tempo para finalizar pode demorar dependendo a quantidade De registros.",
        imageUrl: `${window.urlbase}img/load.gif`,
        showConfirmButton: false,
      });
      axios
        .get("api/dashboard/beneficios", {
          params: {
            page: this.page,
            search: this.search,
            perPage: this.perPage,
            filtroDatas: this.filtroDatas,
            filtroConcessoes:
              this.filtroConcessoes[1] > 0 ? this.filtroConcessoes : null,
            filtroFonteRecursos: this.filtroFonteRecursos,
            filtroCategorias: this.filtroCategorias,
            filtroTipos: this.filtroTipos,
            filtroUnidades: this.filtroUnidades,
            filtroStatus: this.filtroStatus,
            export: "ok",
          },
        })
        .then((response) => {
          this.isLoadingMsg = false;
          this.loading = false;

          swal.fire({
            title: "Arquivo Pronto para Download!",
            html: `<a href="${response.data.link}" target="_blank">Clique aqui para baixar</a>`,
            icon: "success",
            showConfirmButton: false,
          });
        })
        .finally(() => {
          (this.isLoadingMsg = false), (this.loading = false);
        });
    },
    changePage(page) {
      if (
        page > 0 &&
        page <= this.pagination.totalPages &&
        page !== this.page
      ) {
        this.page = page;
        this.getBeneficios();
      }
    },
    redirectBeneficio(id) {
      this.$router.push({
        path: `/dashboard/beneficio/edit/${id}`,
        query: { familia_id: this.$route.query.familia_id },
      });
    },
    redirectLiberar() {
      this.$router.push({
        path: `/dashboard/beneficios/liberar`,
      });
    },
    redirectEntregue() {
      this.$router.push({ path: `/dashboard/beneficios/entrega` });
    },
    getUnidades() {
      this.loadingSearchUnidade = true;
      this.desabledSearchUnidade = true;
      axios
        .get(`api/dashboard/unidades/get/externas`)
        .then((response) => {
          this.unidades = response.data;
        })
        .finally(() => {
          this.loadingSearchUnidade = false;
          this.desabledSearchUnidade = false;
        });
    },
    getTipos() {
      this.loadingSearchTipos = true;
      axios
        .get(`api/dashboard/report/get/beneficios/tipos`)
        .then((response) => {
          this.tipos = response.data;
        })
        .finally(() => (this.loadingSearchTipos = false));
    },
    getSubTipos() {
      this.loadSubtipo = true;
      this.subtipos = [];
      axios
        .get(`api/dashboard/report/get/beneficios/subtipos/${this.tipo}`)
        .then((response) => {
          this.subtipos = response.data;
        })
        .finally(() => {
          this.loadSubtipo = false;
        });
    },
    getStatus() {
      this.loadingStatus = true;
      axios
        .get(`api/dashboard/report/get/beneficios/status`)
        .then((response) => {
          this.status = response.data;
        })
        .finally(() => {
          this.loadingStatus = false;
        });
    },
    limparFiltros() {
      this.data_inicio = "";
      this.data_fim = "";
      this.verificaDataInicial = false;

      this.filtroDatas = [];
      this.filtroConcessoes = [0, this.quatidade_maxima];
      this.filtrarConcessoes = false;
      this.filtroFonteRecursos = [];
      this.filtroCategorias = [];
      this.filtroTipos = [];
      this.filtroUnidades = [];
      this.filtroStatus = [];

      this.getAnalytics();
    },
  },
};
</script>
